import Vue from "vue";
import App from "./App";
import router from "./router";
// import "lib-flexible/flexible";
import "./static/js/flexible.js";
import http from "./api/ajax.js"; //ajax请求
import tools from "./api/tools.js"; //工具
import config from "./api/common.js"; //公共变量
import title from "vue-wechat-title"; //标题更新
import { Lazyload } from 'vant'; //图片懒加载
import weixin from "./api/weixin"; //微信方法
import Vant from "vant"; // vant-ui
import Video from "video.js";
import vueEsign from "vue-esign";
import "video.js/dist/video-js.css";
import "vant/lib/index.css";
import "@vant/touch-emulator";
initVue();
async function initVue() {
  //过滤登录注册
  Vue.use(http);
  Vue.use(tools);
  Vue.use(title);
  Vue.use(config);
  Vue.use(weixin);
  Vue.use(Vant);
  Vue.use(vueEsign);
  Vue.use(Lazyload);
  Vue.directive("title", {
    inserted: function(el, binding) {
      tools.setWebTitle(binding.value);
    },
    update: function(el, binding) {
      tools.setWebTitle(binding.value);
    }
  });
  // 将API方法绑定到全局
  Vue.prototype.$http = http;
  Vue.prototype.$tools = tools;
  Vue.prototype.$config = config;
  Vue.prototype.$weixin = weixin;

  new Vue({
    router,
    render: h => h(App),
    beforeCreate(){
      Vue.prototype.$bus = this;
    }
  }).$mount("#app");
}
